import { api, API_BASE } from "@/lib/api";

export const portraitsApi = {
  list: () => api.get("/my/portraits").then((r) => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api
      .post("/my/portraits", fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
  remove: (id) => api.delete(`/my/portraits/${id}`).then((r) => r.data),
  publicUrl: (relative) => `${API_BASE.replace(/\/api$/, "")}${relative}`,
};

export const cardsApi = {
  occasions: () => api.get("/cards/occasions").then((r) => r.data),
  samples: () => api.get("/cards/samples").then((r) => r.data),
  sampleUrl: (i) => `${API_BASE}/cards/samples/${i}.png`,
  aiSuggest: (payload) => api.post("/cards/ai-suggest", payload).then((r) => r.data),
  saveComposed: (payload) => api.post("/my/cards", payload).then((r) => r.data),
  uploadCard: (file, meta) => {
    const fd = new FormData();
    fd.append("file", file);
    Object.entries(meta).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== "") fd.append(k, v);
    });
    return api
      .post("/my/cards/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
  listMine: () => api.get("/my/cards").then((r) => r.data),
  patchMine: (id, payload) => api.patch(`/my/cards/${id}`, payload).then((r) => r.data),
  removeMine: (id) => api.delete(`/my/cards/${id}`).then((r) => r.data),
  feedIndex: () => api.get("/cards/feed").then((r) => r.data),
  feed: (occasion) => api.get(`/cards/feed/${occasion}`).then((r) => r.data),
  composeBlobUrl: async (payload) => {
    const r = await api.post("/cards/compose", payload, { responseType: "blob" });
    return URL.createObjectURL(r.data);
  },
  composeBlob: async (payload) => {
    const r = await api.post("/cards/compose", payload, { responseType: "blob" });
    return r.data;
  },
};
